/** US national median gross rent (2023 ACS 5-year, B25064). Midpoint (score 5) for affordability. */
export const NATIONAL_MEDIAN_RENT = 1487;

/** Reverse of risk_score (0–1): safety out of 10, rounded. */
export function safetyFromRiskScore(riskScore) {
  if (riskScore == null || Number.isNaN(riskScore)) return null;
  const s = Math.round((1 - Number(riskScore)) * 10);
  return Math.max(0, Math.min(10, s));
}

/**
 * Affordability score 1–10 from ZCTA median rent.
 * Uses national average $1487 as midpoint (score 5).
 * Lower rent = more affordable = higher score.
 */
export function affordabilityFromRent(medianRent) {
  if (medianRent == null || medianRent <= 0 || Number.isNaN(Number(medianRent))) return null;
  const score = 11 - 6 * (Number(medianRent) / NATIONAL_MEDIAN_RENT);
  return Math.max(1, Math.min(10, Math.round(score)));
}

/** Color for any 1–10 score: 1–2 red, 3–5 yellow, 6–10 green. */
export function scoreColor(score) {
  if (score <= 2) return '#dc5c5c';
  if (score <= 5) return '#d4a84b';
  return '#3a9b5e';
}

// Named aliases for readability at call sites
export const safetyScoreColor = scoreColor;
export const affordabilityScoreColor = scoreColor;
export const livabilityScoreColor = scoreColor;
